export const getShortDate = (date: Date) =>
  date
    .toLocaleDateString("default", {
      // day: "numeric",
      month: "short",
      year: "numeric",
    })
    .toLocaleLowerCase();
